import { render, staticRenderFns } from "./RevisionDialog.vue?vue&type=template&id=17f6ced9&scoped=true"
import script from "./RevisionDialog.vue?vue&type=script&lang=js"
export * from "./RevisionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f6ced9",
  null
  
)

export default component.exports